import React from "react";
import { Modal } from "@culturehq/components";

import { useProfile } from "app/context";
import ChqModal from "components/common/ChqModal";
import SurveyResults from "./SurveyResults";

const SurveyCompleted = ({ children, survey }) => {
  const { profile } = useProfile();

  if (!profile.organizationAdmin && survey.creator.id !== profile.id && !survey.viewableResults) {
    return null;
  }

  return (
    <ChqModal entrance="zoomIn" trigger={children}>
      <Modal.Heading>
        {survey.title}
      </Modal.Heading>
      <Modal.Body>
        <SurveyResults survey={survey} />
      </Modal.Body>
    </ChqModal>
  );
};

export default SurveyCompleted;
